import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=138e08d3&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=ts"
export * from "./Alert.vue?vue&type=script&lang=ts"
import style0 from "./Alert.vue?vue&type=style&index=0&id=138e08d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e08d3",
  null
  
)

export default component.exports